import { FC } from 'react';

const Step2Icon: FC<{ color?: string }> = ({ color }) => {
  return (
    <svg
      version="1.1"
      id="Capa_2_00000087387934406579792870000000835685319202881960_"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      height={100}
      fill={color}
      xmlSpace="preserve"
    >
      <g>
        <path
          fill={color}
          d="M601.3,652.5c-8.3,0-15-6.7-15-15V312.4H471.5c-8.3,0-15-6.7-15-15s6.7-15,15-15h129.7c8.3,0,15,6.7,15,15v340.1
		C616.3,645.8,609.5,652.5,601.3,652.5z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M218.3,784.1h-84.6c-8.3,0-15-6.7-15-15V493.5c0-8.3,6.7-15,15-15s15,6.7,15,15v260.6h69.6c8.3,0,15,6.7,15,15
		S226.6,784.1,218.3,784.1z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M616.6,784.1H403.6c-8.3,0-15-6.7-15-15s6.7-15,15-15h212.9c8.3,0,15,6.7,15,15S624.9,784.1,616.6,784.1z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M870.9,784.1h-88.3c-8.3,0-15-6.7-15-15s6.7-15,15-15h73.3V623.7l-68.1-192.9H604.3c-8.3,0-15-6.7-15-15s6.7-15,15-15h194
		c6.4,0,12,4,14.1,10L885,616.2c0.6,1.6,0.9,3.3,0.9,5v148C885.9,777.4,879.2,784.1,870.9,784.1z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M699.3,881.3c-54.4,0-98.7-44.3-98.7-98.7s44.3-98.7,98.7-98.7s98.7,44.3,98.7,98.7S753.7,881.3,699.3,881.3z M699.3,713.8
		c-37.9,0-68.7,30.8-68.7,68.7s30.8,68.7,68.7,68.7s68.7-30.8,68.7-68.7S737.2,713.8,699.3,713.8z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M311.2,882.3c-59.5,0-107.9-48.4-107.9-107.9c0-59.5,48.4-107.9,107.9-107.9s107.9,48.4,107.9,107.9
		C419.1,833.9,370.7,882.3,311.2,882.3z M311.2,696.4c-43,0-77.9,35-77.9,77.9c0,43,35,77.9,77.9,77.9s77.9-35,77.9-77.9
		C389.1,731.4,354.2,696.4,311.2,696.4z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M299,484.2c-101.2,0-183.5-82.3-183.5-183.5c0-101.2,82.3-183.5,183.5-183.5c101.2,0,183.5,82.3,183.5,183.5
		C482.5,401.8,400.2,484.2,299,484.2z M299,147.1c-84.6,0-153.5,68.9-153.5,153.5c0,84.6,68.9,153.5,153.5,153.5
		c84.6,0,153.5-68.9,153.5-153.5C452.5,216,383.7,147.1,299,147.1z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M367.3,313.5H298c-8.3,0-15-6.7-15-15v-65.8c0-8.3,6.7-15,15-15s15,6.7,15,15v50.8h54.4c8.3,0,15,6.7,15,15
		S375.6,313.5,367.3,313.5z"
        />
      </g>
    </svg>
  );
};

export default Step2Icon;
